export type ConfidenceStatus = 'untested' | 'validated' | 'mixed' | 'invalidated'

const CONFIDENCE_COLORS: Record<ConfidenceStatus, string> = {
  untested: '#9ca3af',
  validated: '#10b981',
  mixed: '#f59e0b',
  invalidated: '#ef4444',
}

export const CONFIDENCE_LABELS: Record<ConfidenceStatus, string> = {
  untested: 'No data collected yet',
  validated: 'Strong evidence — proceed',
  mixed: 'Conflicting or insufficient data',
  invalidated: 'Strong evidence against — consider pivoting',
}

export function getConfidenceStatus(score: number | undefined): ConfidenceStatus {
  if (score === undefined) return 'untested'
  if (score >= 70) return 'validated'
  if (score >= 30) return 'mixed'
  return 'invalidated'
}

export function getConfidenceColor(score: number | undefined): string {
  return CONFIDENCE_COLORS[getConfidenceStatus(score)]
}
